import Vue from 'vue'
import Router from 'vue-router'
import AdminLayout from '@/layouts/AdminLayout'
import Dashboard from '@/views/Dashboard'
import Login from '@/views/user/login'

Vue.use(Router)

/** 布局内业务路由（相对 path，最终 URL 保持不变） */
const layoutChildren = [
  {
    path: '',
    name: 'dashboard',
    component: Dashboard,
    meta: {
      keepAlive: false,
      login: true,
      title: '工作台',
      affix: true
    }
  },
  {
    name: 'toBiochemistry',
    path: 'center/biochemistry',
    component: (resolve) => require(['@/views/center/biochemistry/index'], resolve),
    meta: {
      keepAlive: false,
      login: true,
      title: '白医云·医(检查任务)'
    }
  },
  {
    name: 'toMedicineIndex',
    path: 'biochemistry/medicineIndex',
    component: (resolve) => require(['@/views/center/biochemistry/medicineIndex'], resolve),
    meta: {
      keepAlive: false,
      login: false,
      title: '医生接诊'
    }
  },
  {
    name: 'toConsultationIndex',
    path: 'consultation/index',
    component: (resolve) => require(['@/views/center/consultation/index'], resolve),
    meta: {
      keepAlive: false,
      login: false,
      title: '会诊申请'
    }
  },
  {
    name: 'toImageTextInquiry',
    path: 'center/imageTextInquiry',
    component: (resolve) => require(['@/views/center/imageTextInquiry/index'], resolve),
    meta: {
      keepAlive: false,
      login: true,
      title: '白医云·医(图文问诊)'
    }
  },
  {
    name: 'phrase',
    path: 'center/phrase',
    component: (resolve) => require(['@/views/center/phrase/index'], resolve),
    meta: {
      keepAlive: false,
      login: true,
      title: '常用短语管理'
    }
  },
  {
    name: 'microbiota',
    path: 'center/microbiota',
    component: (resolve) => require(['@/views/center/microbiota/index2'], resolve),
    meta: {
      keepAlive: false,
      login: true,
      title: '菌群移植'
    }
  },
  {
    name: 'timChat',
    path: 'center/chat',
    component: (resolve) => require(['@/views/center/imageTextInquiry/chat'], resolve),
    meta: {
      keepAlive: false,
      login: true,
      title: '白医云'
    }
  },
  {
    name: 'trtc',
    path: 'center/trtc',
    component: (resolve) => require(['@/views/center/trtc/index'], resolve),
    meta: {
      keepAlive: false,
      login: true,
      title: '白医云·医(视频问诊)'
    }
  },
  {
    name: 'mq',
    path: 'center/mq',
    component: (resolve) => require(['@/views/center/rabbitmq/index'], resolve),
    meta: {
      keepAlive: false,
      login: true,
      title: '白医云·医(接收任务)'
    }
  },
  {
    name: 'pdf',
    path: 'center/pdf',
    component: (resolve) => require(['@/views/center/pdf/index'], resolve),
    meta: {
      keepAlive: false,
      login: false,
      title: '白医云·医(PDF报告生成)'
    }
  },
  {
    name: 'doctorPrescription',
    path: 'workstation/prescription',
    component: (resolve) => require(['@/views/center/workstation/prescription'], resolve),
    meta: {
      keepAlive: false,
      login: true,
      title: '医生工作站'
    }
  },
  {
    name: 'queryPrescription',
    path: 'workstation/queryPrescription',
    component: (resolve) => require(['@/views/center/workstation/queryPrescription'], resolve),
    meta: {
      keepAlive: false,
      login: true,
      title: '处方查询'
    }
  },
  {
    name: 'clinicMedicalRecord',
    path: 'clinic/medicalRecord',
    component: (resolve) => require(['@/views/center/clinic/medicalRecord'], resolve),
    meta: {
      keepAlive: false,
      login: true,
      title: '门诊病历'
    }
  },
  {
    name: 'clinicalGroup',
    path: 'workstation/clinicalgroup',
    component: (resolve) => require(['@/views/center/workstation/ClinicalGroup'], resolve),
    meta: {
      keepAlive: false,
      login: true,
      title: '协定方'
    }
  },
  {
    name: 'prescriptionAudit',
    path: 'workstation/prescriptionAudit',
    component: (resolve) => require(['@/views/center/workstation/prescriptionAudit'], resolve),
    meta: {
      keepAlive: false,
      login: true,
      title: '处方审核'
    }
  },
  {
    name: 'prescriptionInquiry',
    path: 'workstation/prescriptionInquiry',
    component: (resolve) => require(['@/views/center/workstation/prescriptionInquiry'], resolve),
    meta: {
      keepAlive: false,
      login: true,
      title: '处方查询'
    }
  },
  {
    name: 'recommendedProducts',
    path: 'doctor/recommendedProducts',
    component: (resolve) => require(['@/views/center/doctor/productSelection'], resolve),
    meta: {
      keepAlive: false,
      login: true,
      title: '推荐商品'
    }
  },
  {
    name: 'productSelection',
    path: 'doctor/productSelection',
    component: (resolve) => require(['@/views/center/doctor/productSelection'], resolve),
    meta: {
      keepAlive: false,
      login: true,
      title: '选择推荐商品'
    }
  },
  {
    name: 'recommendedManagement',
    path: 'doctor/recommended-management',
    component: (resolve) => require(['@/views/center/doctor/recommendedProducts'], resolve),
    meta: {
      keepAlive: false,
      login: true,
      title: '已推荐商品管理'
    }
  }
]

export const constantRoutes = [
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/index',
    redirect: { name: 'dashboard' }
  },
  {
    path: '/',
    name: 'layout',
    component: AdminLayout,
    redirect: { name: 'dashboard' },
    meta: {
      login: true
    },
    children: layoutChildren
  },
  {
    name: 'chat',
    path: '/metaverse/chat',
    component: (resolve) => require(['@/views/metaverse/chat'], resolve),
    meta: {
      keepAlive: false,
      login: false,
      title: '白医云·医(智能问诊)'
    }
  },
  {
    path: '/center/ecg',
    component: (resolve) => require(['@/views/center/ecg/index'], resolve),
    meta: {
      keepAlive: false,
      login: true,
      title: '白医云·医(检查任务)'
    }
  },
  {
    path: '/center/report',
    component: (resolve) => require(['@/views/center/report/index'], resolve)
  },
  {
    path: '/center/fileUpload',
    component: (resolve) => require(['@/views/center/fileupload/test'], resolve),
    meta: {
      keepAlive: false,
      login: true,
      title: '白医云·医(文件上传)'
    }
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new Router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const VueRouterPush = Router.prototype.push
Router.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(function (err) { return err })
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js